MoyaEventHandler.on('modal.opened', (e ) => {
	let modalElm = e.modal.element;
	if(modalElm.parentElement.classList.contains('links-modal')) {
		site.extras.itemForm();
	}
});
